import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';
import './advance-filters.css';
import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import {
  LEASEVALUE,
  maxRentValue,
  maxSaleValue,
  minRentValue,
  minSaleValue,
  RENTVALUE,
  SALEVALUE,
} from '../constants/app-constants';
import {
  Box,
  FormControl,
  InputAdornment,
  OutlinedInput,
  Slider,
  Typography,
} from '@mui/material';
import { numDifferentiation, sanitizeData } from '../Utils/helperUtils';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { TRANSLATIONS } from '../Utils/translations';
import { useTranslation } from 'react-i18next';
import TextFieldWithLabel from './textFieldWithLabel';
import CustomButton from './customButton';
import { BUTTON_TITLES } from '../constants/button-titles';
import { ANALYTICS_CATEGORIES } from '../constants/analytics-events';
import { ANALYTICS_EVENT_NAMES } from '../constants/analytics-events-config';

const RenderActiveFilter = (props) => {
  const {
    filterKey,
    setbudgetRange,
    budgetRange,
    propertyType,
    maxBuildUp,
    minBuildUp,
    setMaxBuildUp,
    setMinBuildUp,
    availabilityDate,
    setAvailabilityDate,
    setBudgetApplied,
  } = props;

  const { t } = useTranslation();

  const getMinSliderValue = () => {
    if (propertyType.includes(SALEVALUE) && propertyType.includes(RENTVALUE)) {
      return minRentValue;
    } else if (propertyType.includes(SALEVALUE)) {
      return minSaleValue;
    } else {
      return minRentValue;
    }
  };

  const getMaxSliderValue = () => {
    if (propertyType.includes(SALEVALUE) && propertyType.includes(RENTVALUE)) {
      return maxSaleValue;
    } else if (propertyType.includes(RENTVALUE)) {
      return maxRentValue;
    } else {
      return maxSaleValue;
    }
  };

  const handleChange = (event, newValue) => {
    setBudgetApplied(true);
    setbudgetRange(newValue);
  };
  function valuetext(value) {
    return `${value}`;
  }

  const handleBuildupChange = (val, isMin) => {
    if (isMin) {
      val >= 0 && setMinBuildUp(val);
    } else {
      setMaxBuildUp(val);
    }
  };

  if (filterKey === 'build_up_area') {
    return (
      <div>
        <div className="adv-fil-build-up-area">
          <FormControl sx={{ m: 1 }} variant="outlined">
            {/* <span className="adv-fil-active-label">Min Build Up</span> */}
            <span className="adv-fil-active-label">
              {t(TRANSLATIONS.TITLES.MIN_BUILD_UP)}
            </span>
            <OutlinedInput
              type="number"
              value={minBuildUp}
              onWheel={(e) => {
                e.target.blur();
                e.preventDefault();
              }}
              onChange={(e) => handleBuildupChange(e.target.value, true)}
              endAdornment={
                <InputAdornment
                  sx={{
                    '.MuiTypography-root': {
                      fontSize: '14px',
                    },
                  }}
                  position="end"
                >
                  Sq. ft.
                </InputAdornment>
              }
              aria-describedby="outlined-weight-helper-text"
              size="small"
              autoComplete="off"
              inputProps={{
                'aria-label': 'Sq. Ft',
              }}
              sx={{
                width: 200,
                '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button':
                  {
                    display: 'none',
                  },
                '& input[type=number]': {
                  MozAppearance: 'textfield',
                },
                '.MuiOutlinedInput-input': {
                  fontSize: '14px',
                },
              }}
            />
          </FormControl>
          <FormControl sx={{ m: 1 }} variant="outlined">
            <span className="adv-fil-active-label">
              {t(TRANSLATIONS.TITLES.MAX_BUILD_UP)}
            </span>
            <OutlinedInput
              type="number"
              value={maxBuildUp}
              onWheel={(e) => {
                e.target.blur();
                e.preventDefault();
              }}
              onChange={(e) => handleBuildupChange(e.target.value, false)}
              endAdornment={
                <InputAdornment
                  sx={{
                    '.MuiTypography-root': {
                      fontSize: '14px',
                    },
                  }}
                  position="end"
                >
                  Sq. ft.
                </InputAdornment>
              }
              aria-describedby="outlined-weight-helper-text"
              size="small"
              autoComplete="off"
              inputProps={{
                'aria-label': 'Sq. Ft',
              }}
              sx={{
                width: 200,
                '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button':
                  {
                    display: 'none',
                  },
                '& input[type=number]': {
                  MozAppearance: 'textfield',
                },
                '.MuiOutlinedInput-input': {
                  fontSize: '14px',
                },
              }}
            />
          </FormControl>
        </div>
        {Number(maxBuildUp) > 0 &&
          Number(minBuildUp) > 0 &&
          Number(minBuildUp) > Number(maxBuildUp) && (
            <Typography sx={{ color: 'red', fontSize: '12px' }}>
              Max built-up area should be greater than min built-up area
            </Typography>
          )}
      </div>
    );
  } else if (filterKey === 'budget') {
    const MIN_PRICE = 10000;
    const MAX_PRICE = 1000000000;

    const handleMinInputChange = (e) => {
      const value = e.target.value;

      // Allow empty value during typing
      if (value === '') {
        setbudgetRange(['', budgetRange[1]]);
        return;
      }

      if (!isNaN(value)) {
        setbudgetRange([value, budgetRange[1]]);
        setBudgetApplied(true);
      }
    };

    const handleMaxInputChange = (e) => {
      const value = e.target.value;

      // Allow empty value during typing
      if (value === '') {
        setbudgetRange([budgetRange[0], '']);
        return;
      }

      const newValue = Number(value.replace(/,/g, '')); // Remove commas if present
      if (!isNaN(newValue)) {
        setbudgetRange([budgetRange[0], newValue]);
        setBudgetApplied(true);
      }
    };

    // Validate and correct values on blur
    const handleBlur = (isMin) => {
      let minVal = budgetRange[0];
      let maxVal = budgetRange[1];

      if (isMin) {
        // If empty, set to minimum
        if (minVal === '') {
          minVal = MIN_PRICE;
        } else {
          // Ensure value is within bounds
          minVal = Math.max(
            MIN_PRICE,
            Math.min(minVal, maxVal === '' ? MAX_PRICE : maxVal)
          );
        }
      } else {
        // If empty, set to maximum
        if (maxVal === '') {
          maxVal = MAX_PRICE;
        } else {
          // Ensure value is within bounds
          maxVal = Math.min(
            MAX_PRICE,
            Math.max(maxVal, minVal === '' ? MIN_PRICE : minVal)
          );
        }
      }

      setbudgetRange([minVal, maxVal]);
    };

    return (
      <Box sx={{ width: '95%', padding: 3 }}>
        <Box>
          <Slider
            getAriaLabel={() => 'Price Range'}
            value={[
              budgetRange[0] === '' ? MIN_PRICE : budgetRange[0],
              budgetRange[1] === '' ? MAX_PRICE : budgetRange[1],
            ]}
            onChange={handleChange}
            valueLabelDisplay="on"
            getAriaValueText={valuetext}
            min={Math.max(MIN_PRICE, getMinSliderValue())}
            max={Math.min(MAX_PRICE, getMaxSliderValue())}
            valueLabelFormat={(value) => numDifferentiation(value)}
            sx={{
              width: '100%',
              '.MuiSlider-thumb': {
                width: '10px',
                height: '10px',
              },
              '.MuiSlider-valueLabel': {
                background: '#F5EDFF',
                color: '#7D7D7D',
                borderRadius: '30px',
                top: 50,
                '::before': {
                  // Adjust the arrow pointing direction
                  content: '""',
                  position: 'absolute',
                  width: 0,
                  height: 0,
                  borderLeft: '7px solid #fff',
                  borderRight: '7px solid #fff',
                  borderTop: '7px solid #F5EDFF',
                  top: -6,
                  left: '50%',
                  transform: 'translateX(-50%) rotate(180deg)',
                },
              },
            }}
          />

          <div className="adv-fil-budget">
            <FormControl sx={{ m: 1 }} variant="outlined">
              <span className="adv-fil-active-label">
                {t(TRANSLATIONS.TITLES.MIN_PRICE)}
              </span>
              <TextFieldWithLabel
                type="number" // Changed to text to handle formatting
                value={budgetRange[0]}
                onChange={handleMinInputChange}
                onBlur={() => handleBlur(true)}
                onWheel={(e) => {
                  e.target.blur();
                  e.preventDefault();
                }}
                startAdornment={
                  <InputAdornment position="start">&#8377;</InputAdornment>
                }
                aria-describedby="outlined-weight-helper-text"
                size="small"
                autoComplete="off"
                inputProps={{
                  'aria-label': 'Min Price',
                }}
                sx={{
                  width: { lg: '200px', xs: '150px' },
                  '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button':
                    {
                      display: 'none',
                    },
                  '.MuiOutlinedInput-input': {
                    fontSize: '14px',
                  },
                }}
                convertNumberToWord
              />
              {budgetRange[0] !== '' && budgetRange[0] < MIN_PRICE && (
                <span
                  className="error-message"
                  style={{ color: 'red', fontSize: '12px' }}
                >
                  Minimum value is {numDifferentiation(MIN_PRICE)}
                </span>
              )}
            </FormControl>
            <FormControl sx={{ m: 1 }} variant="outlined">
              <span className="adv-fil-active-label">
                {t(TRANSLATIONS.TITLES.MAX_PRICE)}
              </span>
              <TextFieldWithLabel
                type="number" // Changed to text to handle formatting
                value={budgetRange[1]}
                onChange={handleMaxInputChange}
                onBlur={() => handleBlur(false)}
                onWheel={(e) => {
                  e.target.blur();
                  e.preventDefault();
                }}
                startAdornment={
                  <InputAdornment position="start">&#8377;</InputAdornment>
                }
                aria-describedby="outlined-weight-helper-text"
                size="small"
                autoComplete="off"
                inputProps={{
                  'aria-label': 'Max Price',
                }}
                sx={{
                  width: { lg: '200px', xs: '150px' },
                  '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button':
                    {
                      display: 'none',
                    },
                  '.MuiOutlinedInput-input': {
                    fontSize: '14px',
                  },
                }}
                convertNumberToWord
              />
              {budgetRange[1] < budgetRange[0] && (
                <span
                  className="error-message"
                  style={{ color: 'red', fontSize: '12px' }}
                >
                  Max Price should be greater than Min Price
                </span>
              )}
              {budgetRange[1] !== '' && budgetRange[1] > MAX_PRICE && (
                <span
                  className="error-message"
                  style={{ color: 'red', fontSize: '12px' }}
                >
                  Maximum value is {numDifferentiation(MAX_PRICE)}
                </span>
              )}
            </FormControl>
          </div>
        </Box>
      </Box>
    );
  } else {
    return <></>;
  }
};

export default function AdvanceFiltersModal(props) {
  const {
    open,
    setOpen,
    dropDownValues,
    propertyType,
    setPropertyType,
    houseType,
    setHouseType,
    furnishType,
    setFurnishType,
    bedrooms,
    setBedRooms,
    setLocation,
    budgetRange,
    selectedCity,
    setSelectedCity,
    handleSubmit,
    minBuildUp,
    maxBuildUp,
    availabilityDate,
    setMinBuildUp,
    setMaxBuildUp,
    setBudgetApplied,
    budgetApplied,
  } = props;
  const handleClose = () => setOpen(false);
  const { t } = useTranslation();

  const [selectedFilter, setSelectedFilter] = useState('furnish_types');

  useEffect(() => {
    if (
      houseType?.some((type) =>
        ['Warehouse', 'Showroom', 'Office', 'Shop'].includes(type)
      )
    ) {
      setBedRooms([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [houseType]);

  const handleDropSelection = (value, state, setState) => {
    if (state?.includes(value)) {
      let temparr = state.filter((item) => {
        return item !== value;
      });
      setState(temparr);
    } else {
      setState([...state, value]);
    }
  };

  const getStateValues = (type) => {
    switch (type) {
      case 'bedrooms':
        return { state: bedrooms, setState: setBedRooms };
      case 'cities':
        return { state: selectedCity, setState: setSelectedCity };
      case 'furnish_types':
        return { state: furnishType, setState: setFurnishType };
      case 'new_list_type':
        return { state: propertyType, setState: setPropertyType };
      case 'property_types':
        return { state: houseType, setState: setHouseType };
      default:
        return;
    }
  };

  const getAvailityCount = () => {
    if (propertyType?.includes(RENTVALUE)) {
      return getStateCount(availabilityDate);
    } else return 0;
  };

  const getBuildUpCount = () => {
    if (minBuildUp && maxBuildUp) {
      return 1;
    } else {
      return 0;
    }
  };

  function getStateCount(...arrs) {
    return arrs.filter((item) => {
      if (Array.isArray(item)) {
        return item.length > 0; // Non-empty array
      } else if (typeof item === 'string') {
        return item.trim().length > 0; // Non-empty string (ignoring whitespace)
      } else if (typeof item === 'number') {
        return !isNaN(item); // Valid number
      } else if (typeof item === 'object' && item !== null) {
        if (item instanceof Date) {
          return !isNaN(item.getTime()); // Valid date
        }
        return Object.keys(item).length > 0; // Non-empty object
      } else {
        return false; // Ignore other types (e.g., null, undefined, booleans)
      }
    }).length;
  }

  const handleClear = () => {
    setLocation('');
    setHouseType([]);
    setBedRooms([]);
    setFurnishType([]);
    setMaxBuildUp(0);
    setMinBuildUp(0);
    setBudgetApplied(false);
    budgetRange[0] = 10000;
    budgetRange[1] = 1000000000;
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="advance-fil-container">
          <div className="advance-fil-content">
            <div className="adv-fil-header">
              <span>{t(TRANSLATIONS.TITLES.FILTERS)}</span>
              <span>
                <CloseIcon
                  sx={{ cursor: 'pointer' }}
                  onClick={() => handleClose()}
                />
              </span>
            </div>
            <div className="advance-fil-devider"></div>
            <div className="advance-fil-header-btns">
              <span
                className={`advance-fil-btn ${
                  propertyType?.includes(RENTVALUE) ? 'active-fil-btn' : ''
                }`}
                onClick={() =>
                  handleDropSelection(RENTVALUE, propertyType, setPropertyType)
                }
              >
                {RENTVALUE}
              </span>
              <span
                className={`advance-fil-btn ${
                  propertyType?.includes(SALEVALUE) ? 'active-fil-btn' : ''
                } `}
                onClick={() =>
                  handleDropSelection(SALEVALUE, propertyType, setPropertyType)
                }
              >
                {SALEVALUE}
              </span>
              <span
                className={`advance-fil-btn ${
                  propertyType?.includes(LEASEVALUE) ? 'active-fil-btn' : ''
                } `}
                onClick={() =>
                  handleDropSelection(LEASEVALUE, propertyType, setPropertyType)
                }
              >
                {LEASEVALUE}
              </span>
            </div>
            <div className="advance-fil-filters">
              <div className="advance-fil-disp-list advance-fil-list">
                <span
                  onClick={() => setSelectedFilter('property_types')}
                  className={`advance-fil-item ${
                    selectedFilter === 'property_types'
                      ? 'active-advance-fil-item'
                      : ''
                  }`}
                >
                  {' '}
                  {sanitizeData(houseType) && (
                    <span className="is-selected-fil"></span>
                  )}
                  {t(TRANSLATIONS.TITLES.PROPERTY_TYPE)}
                </span>
                <span
                  onClick={() =>
                    !houseType?.some((type) =>
                      [
                        'Warehouse',
                        'Showroom',
                        'Office',
                        'Shop',
                        'Land/Plot',
                      ].includes(type)
                    ) && setSelectedFilter('bedrooms')
                  }
                  className={`advance-fil-item ${
                    selectedFilter === 'bedrooms'
                      ? 'active-advance-fil-item'
                      : ''
                  }`}
                >
                  {' '}
                  {sanitizeData(bedrooms) && (
                    <span className="is-selected-fil"></span>
                  )}
                  {t(TRANSLATIONS.TITLES.BEDROOMS)}
                </span>
                <span
                  onClick={() => setSelectedFilter('furnish_types')}
                  className={`advance-fil-item ${
                    selectedFilter === 'furnish_types'
                      ? 'active-advance-fil-item'
                      : ''
                  }`}
                >
                  {' '}
                  {sanitizeData(furnishType) && (
                    <span className="is-selected-fil"></span>
                  )}
                  {t(TRANSLATIONS.TITLES.FURNISHING)}
                </span>
                <span
                  onClick={() => setSelectedFilter('build_up_area')}
                  className={`advance-fil-item ${
                    selectedFilter === 'build_up_area'
                      ? 'active-advance-fil-item'
                      : ''
                  }`}
                >
                  {' '}
                  {sanitizeData(minBuildUp) && sanitizeData(maxBuildUp) && (
                    <span className="is-selected-fil"></span>
                  )}
                  {t(TRANSLATIONS.TITLES.BUILD_UP_AREA)}
                </span>
                <span
                  onClick={() => setSelectedFilter('budget')}
                  className={`advance-fil-item ${
                    selectedFilter === 'budget' ? 'active-advance-fil-item' : ''
                  }`}
                >
                  {' '}
                  {sanitizeData(budgetRange) && budgetApplied && (
                    <span className="is-selected-fil"></span>
                  )}
                  Budget
                </span>
                {/* {propertyType?.includes(RENTVALUE) && (
                  <span
                    onClick={() => setSelectedFilter('Availability')}
                    className={`advance-fil-item ${
                      selectedFilter === 'Availability'
                        ? 'active-advance-fil-item'
                        : ''
                    }`}
                  >
                    {' '}
                    {sanitizeData(availabilityDate) && (
                      <span className="is-selected-fil"></span>
                    )}
                    {t(TRANSLATIONS.TITLES.AVAILABILITY)}
                  </span>
                )} */}
              </div>
              <div className="advance-fil-disp-list active-advance-fil-list">
                {dropDownValues[selectedFilter]?.map((item) => (
                  <span
                    onClick={() =>
                      handleDropSelection(
                        item.value,
                        getStateValues(selectedFilter)?.state,
                        getStateValues(selectedFilter)?.setState
                      )
                    }
                    className={`advance-fil-item ${
                      [...getStateValues(selectedFilter)?.state].includes(
                        item.value
                      )
                        ? 'active-advance-fil-item'
                        : ''
                    }`}
                    id={item.value}
                  >
                    {item.value}
                  </span>
                ))}
                <RenderActiveFilter filterKey={selectedFilter} {...props} />
              </div>
            </div>
            <div className="advance-fil-details">
              {getStateCount(houseType, bedrooms, furnishType) +
              getAvailityCount() +
              getBuildUpCount() +
              budgetApplied
                ? 1
                : 0}{' '}
              {t(TRANSLATIONS.TITLES.FILTER_S_ADDED)}
            </div>
          </div>

          <div className="advance-fil-footer">
            <CustomButton
              title={BUTTON_TITLES.CLEAR_ALL}
              onClick={handleClear}
              size={'small'}
              type={'secondary'}
              customStyles={{ m: 1 }}
              category={ANALYTICS_CATEGORIES.SEARCH}
              trackEvent={ANALYTICS_EVENT_NAMES.ADVANCE_FILTER_CLEAR}
            />
            <CustomButton
              title={BUTTON_TITLES.APPLY}
              onClick={() => setOpen(false)}
              size={'small'}
              customStyles={{ m: 1 }}
              setDisable={propertyType?.length === 0}
              category={ANALYTICS_CATEGORIES.SEARCH}
              trackEvent={ANALYTICS_EVENT_NAMES.ADVANCE_FILTER_APPLY}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
}
